import { MdbaseConnectInternals } from "./connect.js";
import { defaultCallbackUrl } from "./runtime-utils.js";
import { AUTHORIZATION_PROBLEM_CODES, REGISTRATION_PROBLEM_CODES, captureConnectOutcome } from "./outcomes.js";
import { MdbaseApplicationSession } from "./application-session.js";
export class MdbaseConnect {
    internals;
    constructor(options) {
        this.internals = new MdbaseConnectInternals(options);
    }
    register(options) {
        return captureConnectOutcome(() => this.internals.register(options), REGISTRATION_PROBLEM_CODES);
    }
    authorize(options = {}) {
        return captureConnectOutcome(() => this.internals.authorize(options), AUTHORIZATION_PROBLEM_CODES);
    }
    /** The ordinary application lifecycle entry point. */
    application(options) {
        return new MdbaseApplicationSession(this, options, this.internals.timeouts);
    }
    manifest(options) {
        return captureConnectOutcome(() => this.internals.manifestDeclaration(options), REGISTRATION_PROBLEM_CODES);
    }
    environment() {
        return this.internals.environment();
    }
    completeAuthorization(callbackUrl, options) {
        return captureConnectOutcome(() => this.internals.completeAuthorization(callbackUrl === undefined ? defaultCallbackUrl() : String(callbackUrl), options), AUTHORIZATION_PROBLEM_CODES);
    }
    connections() {
        return this.internals.connections();
    }
    connection(collectionId) {
        return this.internals.connection(collectionId);
    }
    unavailableReason(collectionId) {
        return this.internals.unavailableReason(collectionId);
    }
    connectionApplicationId(collectionId) {
        return this.internals.connectionApplicationId(collectionId);
    }
    onConnectionsChange(listener) {
        return this.internals.onConnectionsChange(listener);
    }
    forgetAll() {
        for (const connection of this.connections()) {
            this.connection(connection.collectionId)?.forget();
        }
    }
    /** Forget a public TOFU pin after independently verifying a replaced connector. */
    forgetConnectorIdentity(connectorId) {
        this.internals.forgetConnectorIdentity(connectorId);
    }
}
